export const MandatoryOption = {
    newmandatory : "newmandatory",
    oldremovemandatory : "oldremovemandatory",
    replaceoldmandatory : "replaceoldmandatory",
    none : "none"
}